<template>
  <div class="flex-box bg-white bar-padding">
    <van-nav-bar title="分类">
      <template #right>
        <van-icon name="search" size="20" color="#333" @click="goSearch"/>
      </template>
    </van-nav-bar>
    <div class="flex-box-main cat-content">
      <div class="cat-content-side">
        <van-sidebar v-model="activeKey" class="sidebar" @change="onSideChange">
          <van-sidebar-item
            v-for="item in categories"
            :title="item.Name"
            :key="item.Id"
          />
        </van-sidebar>
      </div>
      <div class="cat-content-items">
        <van-row
          v-for="item in categories"
          :key="item.Id"
          v-show="item.Id == currentCategoryId"
        >
          <van-col
            span="8"
            v-for="ch in item.Children"
            :key="ch.Id"
            class="group-item"
            @click="handleItemClick(ch,item.Id)"
          >
            <div class="img">
              <img :src="ch.PictureUrl" />
            </div>
            <div class="name">{{ ch.Name }}</div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div style="height:50px;"></div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
// @ is an alias to /src
import Tabbar from "@/components/Tabbar.vue";

// import { Dialog } from "vant";

export default {
  name: "category",
  data() {
    return {
      activeKey: 0,
      currentCategoryId: 0,
      size: 10,
      page: 1,
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      categories: [],
    };
  },
  components: {
    Tabbar,
  },
  created() {
    this.loadProduct();
  },
  methods: {
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.loadProduct();
      //console.log("下拉");
    },
    loadProduct() {
      //加载商品信息
      this.$ajax
        .get("api/product/categories", {
          params: {
            page: this.page,
            size: this.size,
          },
        })
        .then((response) => {
          this.loading = false;
          this.isLoading = false;
          if (response.data.code === 1) {
            this.categories = response.data.data;
            this.currentCategoryId = this.categories[0].Id;
          }
          //this.finished = true;
        });
    },
    onLoad() {},
    onSideChange(index) {
      this.currentCategoryId = this.categories[index].Id;
    },
    handleItemClick(item,parentId){
      this.$router.push({path:"search_category",query:{categoryId:item.Id,categoryName:item.Name,pcId:parentId}});
    },
    goSearch() {
      this.$router.push({ path: "search", query: { from: "category" } });
    },
  },
};
</script>

<style lang="less" scoped>
.cat-content {
  display: flex;
  height: 100%;
}
.cat-content-side {
  overflow-y: auto;
  box-sizing: border-box;
  padding-bottom: 100px;
}
.cat-content-items {
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
  padding-bottom: 100px;
}
.cat-content-side::-webkit-scrollbar {
  width: 0 !important;
}
.sidebar .van-sidebar-item {
  padding: 12px 12px;
  background-color: #fff;
  color: #666;
}
.sidebar .van-sidebar-item--select {
  font-weight: bold;
  color: #333;
}

.group-item {
  font-size: 13px;
  color: #666;
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  .img {
    width: calc(100% - 20px);
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(248, 248, 248);
    border-radius: 6px;
    img {
      height: calc(100% - 20px);
      max-width: 90%;
      max-height: 90%;
    }
  }
  .name {
    margin-top: 5px;
    margin-bottom: 5px;
    // text-align: center;
  }
  a {
    color: #666;
  }
}
</style>
